<template>
  <div class="head-page">
    <Header :title="$t('address.title')" :isreturn="true" />
    <van-form ref="frm" @submit="onSubmit" style="margin-top: 5px">
      <van-field
        readonly
        clickable
        name="picker"
        :value="value"
        :label="$t('address.bType')"
        :placeholder="$t('address.bType')"
        @click="showPicker = true"
        :rules="[{ required: true }]"
      >
        <template #right-icon>
          <van-icon name="arrow-down" />
        </template>
      </van-field>
      <van-field
        v-model="frm.address"
        :label="$t('address.address')"
        :placeholder="$t('address.addressplaceholder')"
        :rules="[{ required: true }]"
      />
      <div style="margin: 16px">
        <van-button native-type="submit" class="web-btn" v-if="btnshow">
          <van-loading v-if="posting" /><span v-else>{{
          $t("common.binding")
        }}</span></van-button>
      </div>
    </van-form>
    <van-popup v-model="showPicker" position="bottom" round >
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>
    
<script>
import Header from "@/components/Header";
export default {
  name: "MentionAddress",
  components: { Header },
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  data() {
    return {
      value: "",
      columns: [],
      showPicker: false,
      frm: {
        c_id: null,
        address: null,
      },
      posting:false,
      usrsetting:[],
      btnshow:false
    };
  },
  mounted() {
    this.frm.c_id = this.$route.query.id;
    this.getUsrAddress()
  },
  methods: {
    async onSubmit() {
      if(this.posting){
        return
      }
      this.posting = true
      await this.$http({
        method: "post",
        url: "setusraddress",
        data:this.frm
      }).then((res) => {
        this.posting = false
        this.$toast.success(res.msg)
      }).catch(()=>{
        this.posting = false
      }); 
    },
    onConfirm(val) {
      this.value = val.label;
      this.frm.c_id = val.value
      this.usrsetting.forEach(item => {
        if(item.id == this.frm.c_id){
          this.frm.address = item.address
        }
      });
      this.showPicker = false;
      if(this.safeWapConfig.can_edit_address == 1){
        this.btnshow = true
      } else {
        if(this.frm.address && this.frm.address.length > 0){
          this.btnshow = false
        } else {
          this.btnshow = true
        }
      }
    },
    async getAddress() {
      await this.$http({
        method: "get",
        url: "getrecharge",
      }).then((res) => {
        this.columns = [];
        let tmpitem = {}
        res.data.list.forEach((item) => {
          if(this.frm.c_id && this.frm.c_id == item.id){
            tmpitem = { value: item.id, label: item.title }
          }
          this.columns.push({ value: item.id, label: item.title });
        });
        if(!this.frm.c_id){
          tmpitem = this.columns[0]
        }
        this.onConfirm(tmpitem)
      });
    },
    async getUsrAddress(){
      await this.$http({
        method: "get",
        url: "getusraddress",
      }).then((res) => {
       this.usrsetting = res.data
       this.getAddress()
      });
    }
  },
};
</script>
    
    <style>
</style>
    